import React from "react";

function Footer() {
  return (
    <div className="footer bg-gray-600 w-full h-36">
      <p className="text-center">
        Copyright &copy; VIT-AP 2020. All rights reserved.
      </p>
      <p className="text-center">Connect to us through social media!</p>
    </div>
  );
}

export default Footer;
